// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  max-width: 1200px;
  margin: 20px auto;
  padding: 20px;
  background-color: black;
  color: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.menu-heading {
  text-align: center;
  font-size: 2rem;
  color: white;
  margin-bottom: 30px;
}

.category-dropdown {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.category-dropdown label {
  margin-right: 10px;
  font-size: 1rem;
}

select {
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.menu-products {
  margin: 0 20px;
}

.products-heading {
  font-size: 1.5rem;
  margin-bottom: 20px;
  text-align: center;
  color: white;
}

.product-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #ddd;
  transition: background-color 0.2s;
}


.product-details {
  flex-grow: 1;
}

.product-title {
  font-size: 1.25rem;
  margin: 0;
}

.product-attribute {
  margin: 5px 0;
  color: gray;
}

.product-actions {
  display: flex;
  justify-content: flex-end;
}

.product-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.product-button.archive {
  background-color: #dc3545;
  color: white;
}

.product-button.archive:hover {
  background-color: #c82333;
}

.product-button.unarchive {
  background-color: #28a745;
  color: white;
}

.product-button.unarchive:hover {
  background-color: #218838;
}

.no-products {
  text-align: center;
  color: #777;
  font-size: 1.1rem;
  margin-top: 20px;
}

.Bottom12 {
  padding-bottom: 40px;
}

/* Mobile Optimierungen */
@media (max-width: 768px) {
  .menu {
    padding: 10px;
    margin: 10px;
  }

  .menu-heading {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }

  select {
    width: 100%;
  }

  .products-heading {
    font-size: 1.25rem;
  }

  .product-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .product-actions {
    margin-top: 10px;
    width: 100%;
  }

  .product-button {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/private/Admin/kartArchive.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,iCAAiC;AACnC;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".menu {\r\n  max-width: 1200px;\r\n  margin: 20px auto;\r\n  padding: 20px;\r\n  background-color: black;\r\n  color: white;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.menu-heading {\r\n  text-align: center;\r\n  font-size: 2rem;\r\n  color: white;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.category-dropdown {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.category-dropdown label {\r\n  margin-right: 10px;\r\n  font-size: 1rem;\r\n}\r\n\r\nselect {\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n.menu-products {\r\n  margin: 0 20px;\r\n}\r\n\r\n.products-heading {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n  color: white;\r\n}\r\n\r\n.product-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.product-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px;\r\n  border-bottom: 1px solid #ddd;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n\r\n.product-details {\r\n  flex-grow: 1;\r\n}\r\n\r\n.product-title {\r\n  font-size: 1.25rem;\r\n  margin: 0;\r\n}\r\n\r\n.product-attribute {\r\n  margin: 5px 0;\r\n  color: gray;\r\n}\r\n\r\n.product-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.product-button {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.product-button.archive {\r\n  background-color: #dc3545;\r\n  color: white;\r\n}\r\n\r\n.product-button.archive:hover {\r\n  background-color: #c82333;\r\n}\r\n\r\n.product-button.unarchive {\r\n  background-color: #28a745;\r\n  color: white;\r\n}\r\n\r\n.product-button.unarchive:hover {\r\n  background-color: #218838;\r\n}\r\n\r\n.no-products {\r\n  text-align: center;\r\n  color: #777;\r\n  font-size: 1.1rem;\r\n  margin-top: 20px;\r\n}\r\n\r\n.Bottom12 {\r\n  padding-bottom: 40px;\r\n}\r\n\r\n/* Mobile Optimierungen */\r\n@media (max-width: 768px) {\r\n  .menu {\r\n    padding: 10px;\r\n    margin: 10px;\r\n  }\r\n\r\n  .menu-heading {\r\n    font-size: 1.5rem;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  select {\r\n    width: 100%;\r\n  }\r\n\r\n  .products-heading {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .product-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .product-actions {\r\n    margin-top: 10px;\r\n    width: 100%;\r\n  }\r\n\r\n  .product-button {\r\n    width: 100%;\r\n    padding: 10px;\r\n    margin-top: 5px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
